export interface GraphqlNode {
  id?: string
  nid?: number
}

export interface GraphqlEdge<T> {
  cursor?: string
  node: T
}

export const gidToId = (gid: string | number) => typeof gid === 'number' ? gid : Number(String(gid).split('/').pop())

export const edgesToNodes = <T>(edges: GraphqlEdge<T>[]) => edges?.map(i => i.node)

export const graphqlUnpack = <T extends GraphqlNode>(edges: GraphqlEdge<T>[]) => {
  return edgesToNodes<T>(edges)?.map(i => {
    if ('id' in i && typeof i.id == 'string') {
      i.nid = gidToId(i.id)
    }
    return i
  })
}
